import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Home, FindAPlace, DetailsPage } from './pages';

import './App.css';

const App = () => (
  <BrowserRouter>
    <Route exact path="/" component={Home} />
    <Route exact path="/find-a-place" component={FindAPlace} />
    <Route exact path="/details" component={DetailsPage} />
  </BrowserRouter>
);

export default App;
